export type Politeness = "polite" | "assertive";

export const ANNOUNCER_REGION_IDS: Record<Politeness, string> = {
  polite: "app-announcer-polite",
  assertive: "app-announcer-assertive",
};

// Screen readers skip a live region whose text didn't change, so the region is
// emptied first and refilled after a beat; repeating a message re-announces it.
const REFILL_DELAY_MS = 50;

const pendingRefills: Partial<Record<Politeness, number>> = {};
const pendingMessages: Partial<Record<Politeness, string[]>> = {};

/**
 * Reads `message` to screen reader users through the app-level live regions
 * that `LiveAnnouncer` mounts. Use for status and errors that are otherwise
 * only visible (toasts, button labels, transient banners). Messages sent
 * before the region refills are read together so none is dropped.
 */
export function announce(message: string, politeness: Politeness = "polite"): void {
  const text = message.trim();
  const region = document.getElementById(ANNOUNCER_REGION_IDS[politeness]);
  if (!text || !region) return;

  const messages = pendingMessages[politeness] ?? [];
  messages.push(text);
  pendingMessages[politeness] = messages;

  window.clearTimeout(pendingRefills[politeness]);
  region.textContent = "";
  pendingRefills[politeness] = window.setTimeout(() => {
    region.textContent = messages.join(" ");
    delete pendingMessages[politeness];
  }, REFILL_DELAY_MS);
}
